import { useGetCurrentGradeQueryState } from '~/curriculum/apis/curriculum.api'
import { getVideoPosterUrl } from '~/curriculum/utils/videoPoster.utils'
import { useAppSelector } from '~/redux/hooks'
import { selectSelectedGrade } from '~/redux/slices/dashboard'

/** Poster background. Curriculum passes the viewed grade; others fall back to the chosen grade. Cache-only read. */
export default function useVideoPosterUrl(gradeLevelOverride?: number): string {
  const { data: currentGrade } = useGetCurrentGradeQueryState()
  const selectedGrade = useAppSelector(selectSelectedGrade)

  const chosenGradeLevel = currentGrade?.grade ?? Number(selectedGrade)
  const gradeLevel = gradeLevelOverride && gradeLevelOverride > 0 ? gradeLevelOverride : chosenGradeLevel

  return getVideoPosterUrl(Number.isFinite(gradeLevel) ? Number(gradeLevel) : 0)
}
